// src/app/services/loading.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, timer } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  private activeRequests = 0;
  private minimumDisplayTime = 400; // ms, ajustable à 1000 ou plus si tu veux

  show() {
    this.activeRequests++;

    // Si c'est la première requête, on affiche le loader
    if (this.activeRequests === 1) {
      this.loadingSubject.next(true);
    }
  }

  hide() {
    if (this.activeRequests > 0) {
      this.activeRequests--;

      if (this.activeRequests === 0) {
        // On attend un peu avant de cacher pour que le loader reste visible
        timer(this.minimumDisplayTime).subscribe(() => {
          // ⚠️ vérifie qu'aucune autre requête n'est arrivée entre-temps
          if (this.activeRequests === 0) {
            this.loadingSubject.next(false);
          }
        });
      }
    }
  }
}
